import React, { useState } from "react";
import HowItWorks from "./HowItWorks";
import PartnershipSection from "./PartnershipSection";
import logo from "../images/Logo For Website 01.png";
import { Link } from 'react-router-dom';
// const YCombinatorIcon = () => (
//   <svg viewBox="0 0 24 24" className="w-5 h-5 text-orange-500" fill="currentColor">
//     <path d="M0 24V0h24v24H0zM6.951 5.896l4.112 7.708v5.064h1.583v-4.972l4.148-7.799h-1.749l-2.457 4.875c-.372.745-.688 1.434-.688 1.434s-.297-.708-.651-1.434L8.831 5.896h-1.88z" />
//   </svg>
// );
const VideoSection = () => (
  <div className="max-w-6xl mx-auto mb-24">
    <div className="relative pt-[56.25%] w-full rounded-2xl overflow-hidden shadow-xl">
      <iframe
        className="absolute top-0 left-0 w-full h-full"
        src="https://www.youtube.com/embed/kGo83z_e3Gs?si=Dzgqn37MDE55HygT"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  </div>
);

const DarkCTASection = ({ onGetStarted }) => (
  <div className="relative w-full bg-zinc-900 rounded-3xl overflow-hidden my-24">
    {/* Gradient Orbs */}
    <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/30 rounded-full blur-3xl" />
    <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-orange-500/20 rounded-full blur-3xl" />
    <div className="absolute top-1/2 right-1/3 w-24 h-24 bg-orange-500/20 rounded-full blur-2xl" />

    <div className="relative max-w-7xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center justify-between gap-12">
      {/* Left content */}
      <div className="flex-1 text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-4">
          Transform Your Teaching with AI
        </h2>
        <p className="text-xl text-zinc-400 mb-6">
          Experience personalized education powered by advanced AI assistance
        </p>
        <button
          onClick={onGetStarted}
          className="px-8 py-3 bg-white text-zinc-900 rounded-full text-lg font-medium hover:bg-zinc-100 transition-colors"
        >
          Schedule a Demo
        </button>
      </div>

      {/* Right illustration */}
      <div className="flex-1 relative min-h-[180px]">
        <div className="absolute inset-0 bg-zinc-800/50 rounded-xl overflow-hidden">
          <div className="p-4 space-y-3">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-zinc-700 rounded-full" />
              <div className="h-4 bg-zinc-700 rounded w-48" />
            </div>
            <div className="h-20 bg-zinc-700 rounded" />
            <div className="h-24 bg-zinc-700 rounded" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

const FAQ = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-zinc-200">
      <button
        className="py-6 w-full flex justify-between items-center text-left hover:text-orange-500 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-lg font-semibold pr-8">{question}</h3>
        <div
          className={`w-6 h-6 flex items-center justify-center rounded-full border border-current transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <svg
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-48" : "max-h-0"
        }`}
      >
        <p className="pb-6 text-zinc-600">{answer}</p>
      </div>
    </div>
  );
};

const LandingPage = ({ onGetStarted, onSignup }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="w-full px-4 sm:px-6 lg:px-8 sticky top-0 bg-white/80 backdrop-blur-sm z-50 border-b border-zinc-100">
        <div className="max-w-6xl mx-auto flex justify-between items-center py-4">
          <div className="flex items-center">
            {/* Logo with fallback */}
            <div className="flex items-center">
              <img
                src={logo} // Replace with your actual logo path
                alt="Moinduel Logo"
                className="h-8 w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = "none";
                  // Fallback to text if image fails to load
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <span
                className="font-bold text-xl text-zinc-900 hidden"
                style={{ display: "none" }}
              >
                Moinduel
              </span>
            </div>
          </div>
          <button
            onClick={onSignup}
            className="px-6 py-2 rounded-full border border-zinc-200 hover:bg-zinc-50 hover:border-zinc-300 transition-colors"
          >
            Sign up
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-6 pt-16 relative">
        {/* Y Combinator Badge */}
        {/* <div className="flex justify-center items-center gap-2 mb-8">
          <span className="text-zinc-600">Backed by</span>
          <div className="flex items-center gap-1">
            <YCombinatorIcon />
            <span className="text-orange-500">Combinator</span>
          </div>
        </div> */}
        {/* Hero Section */}
        <div className="text-center mb-24">
          <div className="bg-orange-50 text-orange-500 text-2xl md:text-5xl font-bold inline-block px-3 py-1 md:px-4 md:py-2 rounded-lg mb-4">
            AI Learning Platform
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-zinc-900 mb-6 md:mb-8 max-w-3xl mx-auto leading-tight">
            Transforming Education
          </h1>

          <div className="space-y-3 md:space-y-4 mb-8 md:mb-12">
            <p className="text-lg md:text-xl text-zinc-600">
              Empowering teachers and students with AI-powered learning
            </p>
            <p className="text-lg md:text-xl text-zinc-600">
              Personalized education at scale
            </p>
          </div>

          {/* <button
            onClick={onGetStarted}
            className="px-8 py-4 bg-orange-500 text-white rounded-full text-lg font-medium hover:bg-orange-600 transition-colors"
          >
            Get started
          </button> */}
          <div className="flex justify-center gap-4">
    <button
      onClick={onGetStarted}
      className="px-8 py-4 bg-orange-500 text-white rounded-full text-lg font-medium hover:bg-orange-600 transition-colors"
    >
      Get started
    </button>
    
  </div>
        </div>
        <VideoSection />
        <HowItWorks />
        {/* FAQ Section */}
        <section className="py-24">
          <h2 className="text-4xl font-bold text-zinc-900 mb-12 text-center">
            Frequently asked questions
          </h2>
          <div className="text-left max-w-3xl mx-auto">
            <FAQ
              question="How does Moinduel enhance teaching?"
              answer="Our AI platform assists teachers with lesson planning, content creation, and student progress tracking, allowing them to focus on what matters most - inspiring students."
            />
            <FAQ
              question="What makes Moinduel unique?"
              answer="We combine advanced AI technology with pedagogical expertise to deliver truly personalized learning experiences that adapt to each student's pace and style."
            />
            <FAQ
              question="What subjects are supported?"
              answer="Moinduel covers core subjects including Mathematics, Sciences, Languages, and Humanities, with curriculum-aligned content for different education levels."
            />
            <FAQ
              question="How do you ensure learning effectiveness?"
              answer="We use data-driven insights and continuous assessment to track progress, identify gaps, and adjust learning paths in real-time for optimal results."
            />
          </div>
        </section>
        <DarkCTASection onGetStarted={onGetStarted} />
        {/* Footer */}
        <footer className="border-t border-zinc-200 py-12 mt-24">
          <div className="max-w-5xl mx-auto px-6">
            <div className="flex flex-col items-center gap-4">
              {/* Logo */}
              <img
                src={logo}
                alt="Moinduel Logo"
                className="h-8 w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <span
                className="font-bold text-xl text-zinc-900 hidden"
                style={{ display: "none" }}
              >
                Moinduel
              </span>

              {/* Links */}
              <div className="flex gap-6 text-zinc-600">
                <a
                  href="/privacy-policy"
                  className="hover:text-orange-500 transition-colors"
                >
                  Privacy Policy
                </a>
                <a
                  href="mailto:infomoinduel@gmail.com"
                  className="hover:text-orange-500 transition-colors"
                >
                  infomoinduel@gmail.com
                </a>
              </div>

              {/* Copyright */}
              <div className="text-zinc-600">
                © 2024 Moinduel. All rights reserved.
                
              </div>
              
            </div>
          </div>
        </footer>
        );
        {/* Decorative Elements */}
        <div className="absolute top-1/2 -left-24 w-48 h-48 bg-orange-500 rounded-full opacity-10 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-zinc-500 rounded-full opacity-10 blur-3xl" />
        <div className="absolute top-1/4 right-12 w-24 h-24 bg-zinc-200 rounded-full opacity-50" />
      </main>
    </div>
  );
};

export default LandingPage;
